// @ts-nocheck
import React from 'react';
import axios from "axios";
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import { setupInterceptorsTo } from "../../Componentes/API/AxiosBuilder";
import Typography from "@mui/material/Typography";
import Divider from '@mui/material/Divider';
import SinapThemev2 from "../../styles/SinapThemev2";
import useMediaQuery from '@mui/material/useMediaQuery';
import { ThemeProvider, StyledEngineProvider, styled } from '@mui/material/styles';
import { TextFieldRojo } from "../../App";
import Modal from '@mui/material/Modal';
import { useUsuarios } from "../State/UsuarioContext";
import CircularIndeterminate from "../../Componentes/CircularIndeterminate";
import Grid from "@mui/material/Grid";
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { SaveButton } from "../../Componentes/inputs/SaveButton";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Stack from '@mui/material/Stack';
import { useAuth } from "../../Auth/State/AuthContext";
import { useBody } from "../../Body/state/BodyContext";

const CloseButton = styled(IconButton)(({ theme }) => ({
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
}));

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 380,
    maxHeight: '70vh',
    overflowY: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: 3,
    p: 4,
    outline: 'none',
    position: 'relative'
};

export default function ModalForzarPassword({ prev, open, onClose, ...props }) {
    const matches = useMediaQuery('(max-width:600px)');
    const { handleSuspend } = useUsuarios();
    const { user } = useAuth();
    const { loadingBackdrop, setLoadingBackdrop, setMessage } = useBody();
    const [motivo, setMotivo] = React.useState("");
    const [loading, setLoading] = React.useState(false);
    const [value, setValue] = React.useState('otro');

    const handleChange = (event) => {
        setValue(event.target.value);
    };

    const suspender = async () => {
        if (motivo.trim() === "" && value === 'otro') {
            setMessage("La descripción no puede estar vacía");
            return;
        }
        setLoadingBackdrop(true);
        if (value !== 'otro')
            await handleSuspend(value, prev);
        else
            await handleSuspend(motivo, prev);
        setLoadingBackdrop(false);
        onClose();
    };

    const handleChangeMotivo = (e) => {
        setMotivo(e.target.value);
    };

    React.useEffect(() => {
        if (prev !== undefined && prev.uid !== '') {
            // aquí podrías hacer algo si necesitas
        }
    }, [prev]);

    return (
        <Modal
            keepMounted
            open={open}
            onClose={onClose}
            aria-labelledby="modal-titulo"
            aria-describedby="modal-descripcion"
        >
            <Box sx={modalStyle}>
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={SinapThemev2}>
                        <CloseButton aria-label="Cerrar modal" onClick={onClose}>
                            <CloseIcon />
                        </CloseButton>

                        {loading ? (
                            <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: 200 }}>
                                <CircularIndeterminate />
                            </Grid>
                        ) : (
                            <Stack spacing={3}>
                                <Typography
                                    id="modal-titulo"
                                    variant={matches ? "h5" : "h4"}
                                    component="h2"
                                    color="primary"
                                >
                                    Datos del Usuario
                                </Typography>

                                <Divider />

                                <Stack spacing={1} mt={1} mb={3}>
                                    <Typography variant="subtitle1">Apellido: {prev.apellido}</Typography>
                                    <Typography variant="subtitle1">Nombre: {prev.nombre}</Typography>
                                    <Typography variant="subtitle1">Nombre de usuario: {prev.uid}</Typography>
                                    <Typography variant="subtitle1">Mail FRBA: {prev.frbaEmail}</Typography>
                                    <Typography variant="subtitle1">Mail Alternativo: {prev.personalEmail}</Typography>
                                </Stack>

                                <Typography
                                    variant={matches ? "h5" : "h4"}
                                    color="primary"
                                    component="h3"
                                >
                                    Detalles del cambio
                                </Typography>

                                <Divider />

                                <FormControl component="fieldset" sx={{ mt: 2 }}>
                                    <FormLabel component="legend" id="radio-buttons-group-label" sx={{ mb: 1 }}>
                                        Motivo
                                    </FormLabel>
                                    <RadioGroup
                                        aria-labelledby="radio-buttons-group-label"
                                        name="motivo-radio-group"
                                        value={value}
                                        onChange={handleChange}
                                    >
                                        <FormControlLabel value="spam" control={<Radio />} label="Spam" />
                                        <FormControlLabel value="otro" control={<Radio />} label="Otro/s" />
                                    </RadioGroup>
                                    {value === "otro" && (
                                        <TextFieldRojo
                                            variant="outlined"
                                            fullWidth
                                            multiline
                                            minRows={2}
                                            value={motivo}
                                            onChange={handleChangeMotivo}
                                            placeholder="Escribe el motivo..."
                                            sx={{ mt: 2 }}
                                        />
                                    )}
                                </FormControl>

                                <Grid container justifyContent="center" mt={2}>
                                    <SaveButton label={"Confirmar"} onClick={suspender} type="button" />
                                </Grid>
                            </Stack>
                        )}
                    </ThemeProvider>
                </StyledEngineProvider>
            </Box>
        </Modal>
    );
}
